<nav data-cy="navbar" class="navbar navbar-dark navbar-expand-md bg-dark">
  <div class="container">
    <a class="navbar-brand logo" routerLink="/" (click)="collapseNavbar()">
      <span class="navbar-version">{{ version }}</span>
    </a>
    <a
      class="navbar-toggler d-lg-none"
      href="javascript:void(0);"
      data-toggle="collapse"
      data-target="#navbarResponsive"
      aria-controls="navbarResponsive"
      aria-label="Toggle navigation"
      (click)="toggleNavbar()"
    >
      <fa-icon icon="bars"></fa-icon>
    </a>
    <div class="navbar-collapse collapse" id="navbarResponsive" [ngbCollapse]="isNavbarCollapsed" [ngSwitch]="account !== null">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item" *jhiHasAnyAuthority="'ROLE_ADMIN'" routerLinkActive="active" routerLink="admin/bacheca">
          <a class="nav-link" routerLink="/" (click)="collapseNavbar()">
            <span>
              <fa-icon icon="home"></fa-icon>
              <span jhiTranslate="global.menu.home">Home</span>
            </span>
          </a>
        </li>

        <li class="nav-item" *jhiHasAnyAuthority="'ROLE_USER'" routerLinkActive="active" routerLink="#">
          <a class="nav-link" routerLink="/" (click)="collapseNavbar()">
            <span>
              <fa-icon icon="home"></fa-icon>
              <span jhiTranslate="global.menu.home">Home</span>
            </span>
          </a>
        </li>

        <li class="nav-item" *jhiHasAnyAuthority="'ROLE_EMPLOYEE'" routerLinkActive="active" routerLink="#">
          <a class="nav-link" routerLink="/" (click)="collapseNavbar()">
            <span>
              <fa-icon icon="home"></fa-icon>
              <span jhiTranslate="global.menu.home">Home</span>
            </span>
          </a>
        </li>
        <!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here -->
        <li
          *ngSwitchCase="true"
          ngbDropdown
          class="nav-item dropdown pointer"
          display="dynamic"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="entity-menu">
            <!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here -->
          </ul>
        </li>
        <li
          *jhiHasAnyAuthority="'ROLE_ADMIN'"
          ngbDropdown
          class="nav-item dropdown pointer"
          display="dynamic"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="admin-menu" data-cy="adminMenu">
            <span>
              <fa-icon icon="users-cog"></fa-icon>
              <span jhiTranslate="global.menu.admin.main">Amministratore</span>
            </span>
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="admin-menu">
            <li>
              <a class="dropdown-item" routerLink="admin/gateway" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="road" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.admin.gateway">Gateway</span>
              </a>
            </li>
            <li *ngIf="openAPIEnabled">
              <a class="dropdown-item" routerLink="admin/docs" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="book" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.admin.apidocs">API</span>
              </a>
            </li>
            <li *ngIf="openAPIEnabled">
              <a class="dropdown-item" routerLink="admin/bacheca" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="book" [fixedWidth]="true"></fa-icon>
                <span >Bacheca</span>
              </a>
            </li>
            <!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here -->
          </ul>
        </li>
        <!--
        <li ngbDropdown class="nav-item dropdown pointer" display="dynamic" *ngIf="languages && languages.length > 1">
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="languagesnavBarDropdown">
            <span>
              <fa-icon icon="flag"></fa-icon>
              <span jhiTranslate="global.menu.language">Lingua</span>
            </span>
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="languagesnavBarDropdown">
            <li *ngFor="let language of languages">
              <a
                class="dropdown-item"
                [jhiActiveMenu]="language"
                href="javascript:void(0);"
                (click)="changeLanguage(language); collapseNavbar()"
              >{{ language | findLanguageFromKey }}</a
              >
            </li>
          </ul>
        </li>
        -->
        <li
          ngbDropdown
          class="nav-item dropdown pointer"
          display="dynamic"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="account-menu" data-cy="accountMenu">
            <span *ngIf="!account?.imageUrl">
              <fa-icon icon="user"></fa-icon>
              <span jhiTranslate="global.menu.account.main">Utente</span>
            </span>
            <span *ngIf="account?.imageUrl">
              <img [src]="account!.imageUrl" class="profile-image rounded-circle" alt="Avatar" />
            </span>
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="account-menu">
            <li *ngSwitchCase="true">
              <a class="dropdown-item" (click)="logout()" id="logout" data-cy="logout">
                <fa-icon icon="sign-out-alt" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.account.logout">Esci</span>
              </a>
            </li>
            <li *ngSwitchCase="false">
              <a class="dropdown-item" (click)="login()" id="login" data-cy="login">
                <fa-icon icon="sign-in-alt" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.account.login">Accesso</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
